import { DEAL_SUM_MILLION } from '@entities/clients';

export interface DealsSummFilter {
  from: string;
  to: string;
}

export const EMPTY_DEALS_SUMM: DealsSummFilter = { from: '', to: '' };

export const dealsSummMillionsToRubles = (value: string): number | null =>
  value === '' ? null : Number(value) * DEAL_SUM_MILLION;

export const isDealsSummRangeValid = ({ from, to }: DealsSummFilter): boolean => {
  if (from === '' || to === '') return true;
  return Number(from) <= Number(to);
};
